import type { SelectionAreaPoint } from "../../types";
import type { DoesSegmentIntersectRing } from "./types";

// Verbatim twin of nest_backend .../quantity-surveyor-selection-areas/helpers/doesSegmentIntersectRing — keep in sync.
const orientation = (
  a: SelectionAreaPoint,
  b: SelectionAreaPoint,
  c: SelectionAreaPoint,
): number => {
  return Math.sign((b.x - a.x) * (c.y - a.y) - (b.y - a.y) * (c.x - a.x));
};

const isOnSegment = (
  a: SelectionAreaPoint,
  b: SelectionAreaPoint,
  point: SelectionAreaPoint,
): boolean => {
  return (
    Math.min(a.x, b.x) <= point.x &&
    point.x <= Math.max(a.x, b.x) &&
    Math.min(a.y, b.y) <= point.y &&
    point.y <= Math.max(a.y, b.y)
  );
};

const doSegmentsIntersect = (
  firstStart: SelectionAreaPoint,
  firstEnd: SelectionAreaPoint,
  secondStart: SelectionAreaPoint,
  secondEnd: SelectionAreaPoint,
): boolean => {
  const orientation1 = orientation(firstStart, firstEnd, secondStart);
  const orientation2 = orientation(firstStart, firstEnd, secondEnd);
  const orientation3 = orientation(secondStart, secondEnd, firstStart);
  const orientation4 = orientation(secondStart, secondEnd, firstEnd);

  if (orientation1 !== orientation2 && orientation3 !== orientation4) {
    return true;
  }

  // Collinear touch cases: an endpoint of one segment lies on the other.
  if (orientation1 === 0 && isOnSegment(firstStart, firstEnd, secondStart))
    return true;
  if (orientation2 === 0 && isOnSegment(firstStart, firstEnd, secondEnd))
    return true;
  if (orientation3 === 0 && isOnSegment(secondStart, secondEnd, firstStart))
    return true;
  if (orientation4 === 0 && isOnSegment(secondStart, secondEnd, firstEnd))
    return true;

  return false;
};

export const doesSegmentIntersectRing: DoesSegmentIntersectRing = ({
  segmentStart,
  segmentEnd,
  ring,
}) => {
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i, i++) {
    if (doSegmentsIntersect(segmentStart, segmentEnd, ring[j], ring[i])) {
      return true;
    }
  }
  return false;
};
